import type { AgmAfsDocKind } from './agmAfsDocVariableMap';
import { ALL_DOC_KINDS } from './agmAfsDocVariableMap';

export interface AgmAfsFormSectionDef {
  id: string;
  title: string;
  icon: string;
  docKinds: AgmAfsDocKind[];
  fieldKeys: string[];
}

const DOCS_AGM_SCHEDULE: AgmAfsDocKind[] = [
  'attendance',
  'consent',
  'directors_resolution',
  'minutes_multiple',
  'minutes_sole_corporate',
  'minutes_sole_individual',
  'notice',
];

const DOCS_FYE_AR: AgmAfsDocKind[] = [
  'directors_resolution',
  'minutes_multiple',
  'minutes_sole_corporate',
  'minutes_sole_individual',
  'notice',
];

const DOCS_AGENDA: AgmAfsDocKind[] = [
  'directors_resolution',
  'notice',
  'minutes_multiple',
  'minutes_sole_corporate',
  'minutes_sole_individual',
];

export const AGM_AFS_FORM_SECTIONS: AgmAfsFormSectionDef[] = [
  {
    id: 'company',
    title: 'Company',
    icon: 'mdi:domain',
    docKinds: [...ALL_DOC_KINDS],
    fieldKeys: ['company_name', 'company_registration_no'],
  },
  {
    id: 'registered-office',
    title: 'Registered Office Address',
    icon: 'mdi:map-marker',
    docKinds: ['consent', 'notice'],
    fieldKeys: ['registered_office_address'],
  },
  {
    id: 'agm-schedule',
    title: 'AGM Date / Time & Venue / Financial Year',
    icon: 'mdi:calendar-clock',
    docKinds: DOCS_AGM_SCHEDULE,
    fieldKeys: ['agm_date', 'agm_time', 'agm_venue', 'financial_year_end_date', 'annual_return_year'],
  },
  {
    id: 'agm-options',
    title: 'AGM Agenda Options',
    icon: 'mdi:tune-variant',
    docKinds: DOCS_AGENDA,
    fieldKeys: [
      'is_short_notice',
      'has_directors_remuneration',
      'has_retiring_directors',
      'auditor_name',
      'director.name',
    ],
  },
  {
    id: 'members-chairman',
    title: 'Member Type / Members / Chairman',
    icon: 'mdi:account-group',
    docKinds: ['attendance', 'consent', 'minutes_multiple', 'minutes_sole_corporate', 'minutes_sole_individual'],
    fieldKeys: ['member_structure', 'member.name', 'member_name', 'member_representative_name', 'chairman_name'],
  },
  {
    id: 'directors-resolution',
    title: "Directors' Resolution — Signers",
    icon: 'mdi:account-tie',
    docKinds: ['directors_resolution'],
    fieldKeys: ['director_count', 'specify_signers', 'signer.name'],
  },
  {
    id: 'document-dates',
    title: 'Resolution / Notice / Consent Dates',
    icon: 'mdi:calendar-edit',
    docKinds: ['directors_resolution', 'notice', 'consent'],
    fieldKeys: ['resolution_date', 'notice_date', 'consent_date'],
  },
];

export function docNamesForSection(
  section: AgmAfsFormSectionDef,
  docs: Array<{ name: string; kind: AgmAfsDocKind }>,
): string[] {
  return docs.filter((d) => section.docKinds.includes(d.kind)).map((d) => d.name);
}
